<template>

    <div class="vld-parent">

        <loading :active="componentLoading" :is-full-page="false" :can-cancel="true"></loading>

        <!-- BEGIN SECTION MODULE -->
        <div class="w-full bg-theme-level4 border-b border-theme-level2">

            <div id="sectionHeader" class="p-6 border-b border-theme-level2 flex flex-row items-center justify-between">
                <h2 class="text-theme-discrete font-bold text-xl cursor-pointer" v-text="theSectionTitle" @click="showCategory"></h2>
                <div id="section-controls">
                    <i id="section-info-config" class="material-icons mr-2 cursor-pointer w-4 h-4 text-theme-xmuted hover:text-theme-muted invisible" style="font-size: 20px;">settings</i>
                    <i id="section-info-control" class="material-icons mr-2 cursor-pointer w-4 h-4 text-theme-discrete hover:text-theme-main invisible" style="font-size: 20px;">info_outline</i>
                    <i v-if="controls_enabled && userLoggedIn"
                       id="section-config-control"
                       class="material-icons mr-2 cursor-pointer w-4 h-4 text-theme-discrete hover:text-theme-title"
                       style="font-size: 20px;"
                       :title="translate('hide')"
                       @click="hideSection(category_id)"
                    >highlight_off</i>
                </div>
            </div>

            <!-- BEGIN SECTION CONTENT -->
            <div id="section-content" class="section-container py-5 px-4 bg-theme-level3 text-theme-main" ref="sectionContainer">

                    <content-module-large
                        v-if="largeContent"
                        :content="largeContent"
                        :currentlocale="currentlocale"
                        :legacy="largeContent.legacy"
                        :default_thumbnail="default_thumbnail"
                        :key="largeContent.id"
                        style="order: 1;"
                    ></content-module-large>

                    <!--<content-module-large
                        v-for="(contentPiece, index) in contentPayload" v-if="(contentPiece.render_size === 'Grande' || contentPiece.render_size === 'Large')"
                        v-bind:key="contentPiece.id"
                        :content="contentPiece"
                        :currentlocale="currentlocale"
                        :legacy="contentPiece.legacy"
                        :default_thumbnail="default_thumbnail"
                        style="order: 1;"
                    ></content-module-large>-->

                    <content-module-small
                        v-for="(contentPiece, index) in contentPayload"
                        v-bind:key="contentPiece.id"
                        :content="contentPiece"
                        :currentlocale="currentlocale"
                        :legacy="contentPiece.legacy"
                        :default_thumbnail="default_thumbnail"
                        style="order: 2;"
                    >
                    </content-module-small>

            <!-- END SECTION CONTENT -->
            </div>

        <!-- END SECTION MODULE -->
        </div>
    </div>
</template>

<script>

    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';

    const Lang = require('lang.js');
    import translations from './messages.js';

    const lang = new Lang();

    lang.setMessages(translations);

    export default {

        components: {
            Loading
        },

        data() {
            return {
                componentLoading: true,
                publish_date: '22/03/2020 24:58',
                largeContent: '',
                contentPayload: '',
                large_count: 0,

                fullPage: false
            }
        },

        props: [
            'category_id',
            'filter',
            'sectiontitle_es',
            'sectiontitle_en',
            'currentlocale',
            'contentCount',
            'default_thumbnail',
            'controls_enabled'
        ],

        computed: {

            theSectionTitle() {
                return this.currentlocale==='es' ? this.sectiontitle_es : this.sectiontitle_en;
            },

            piecesToShow() {
                return this.contentCount==='0' ? 1000 : this.contentCount;
            },

            userLoggedIn() {

                return Laravel.user !== null

            }

            /*filteredLargeContent() {

                /!*console.log(Object.entries(this.contentPayload))*!/

                if(this.currentlocale==='es') {
                    return Object.entries(this.contentPayload).filter(item => item.render_size === 'Grande');
                } else {
                    return Object.entries(this.contentPayload).filter(item => item.render_size === 'Large');
                }

            }*/

        },

        methods: {

            showCategory() {
                window.location = '/' + this.currentlocale + '/category/' + this.filter + '/' + this.sectiontitle_es + '/' + this.sectiontitle_en
            },

            translate(key) {
                key = 'strings.' + key;
                return lang.get(key);
            },

            hideSection(category_id) {

                axios.get('/' + this.language + '/prefs/home/update/' + Laravel.user.id + '/' + category_id)
                    .then(response => {
                        window.location.reload()
                    })
                    .catch(error => {
                        this.flashMessage.error({
                            title: '',
                            message: this.translate('up-pref-update-error'),
                            blockClass: 'p-6',
                            x: 25,
                            y: 70,
                            time: 3000
                        });
                    })

            }

        },

        mounted() {

            /*this.componentLoading = false;*/
            /*console.log('A ContentSection module was mounted.');*/
            // Event.fire('closeSidebar');
        },

        created() {

            this.componentLoading = true;

            /*console.log('Getting data for a SECTION component...');
            console.log('Current LARGE Module Count is...: ' + this.large_count);*/

            if(this.contentCount > 0) {

                axios.get('/api/filter/category/' + this.filter + '/' + this.currentlocale)
                    .then(response => {
                        /*console.log('Server Responded well... moving on.');*/
                        /*this.contentPayload = response.data;*/
                        let tmpHolder = response.data;
                        this.contentPayload = tmpHolder[0];
                        this.largeContent = tmpHolder[1];
                        this.componentLoading = false;
                        /*console.log('DONE with data for section');*/
                    })
                    .catch(error => {
                        this.componentLoading = false;
                        console.log('SERVER ERROR!! --> ' + JSON.stringify(error));
                    });

            } else {

                axios.get('/api/filter/category/all/' + this.filter + '/' + this.currentlocale)
                    .then(response => {
                        /*console.log('Server Responded well... moving on.');*/
                        this.contentPayload = response.data;
                        this.componentLoading = false;
                        /*console.log('DONE with data for section');*/
                    })
                    .catch(error => {
                        this.componentLoading = false;
                        console.log('SERVER ERROR!! --> ' + JSON.stringify(error));
                    });

            }

            /*Event.listen('increaseLargeCounter', () => {
                this.large_count = this.large_count + 1;
            });*/
        },

    }

</script>


<style>

    :root {
        --gutter: 20px;
    }

    .section-container {

        display: grid;
        /*grid-gap: calc(var(--gutter) / 2);*/
        grid-gap: 35px;
        grid-template-columns: repeat(auto-fill, minmax(215px, 1fr));
        /*grid-template-rows: 280px 280px;*/
        /*grid-template-rows: 280px 280px;*/
        grid-template-rows: 280px;
        max-height: 630px;
        overflow: hidden;
        /*grid-auto-rows: 280px;*/
    }

    .section-container {
        /* overflow-y: scroll; */
    }

    .hs > li,
    .item {
        scroll-snap-align: center;
        padding: calc(var(--gutter) / 2 * 1.5);
        /*margin-top: 10px;
        margin-bottom: 10px;*/
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        background: #fff;
        border-radius: 8px;
    }

</style>
